import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["hidden", "imageField", "selectedImagesLength", "uploadedImage"];

  connect() {
    this.gameType = document.getElementById("game_type").value;
    this.imagesContainer = document.querySelector(".images-container")
    this.slotImagesContainer = document.querySelector(".upload-images")
    this.uploadedFields = document.getElementById("upload_images")
    this.uploadedImagesArray = document.getElementById("uploaded_images")
    this.previousParent = document.getElementById("general_images")
    this.selectedFieldsId = document.getElementById("selected_images_id");
    this.selectedFields = document.getElementById("selected_images")
    if (this.imageFieldTarget.dataset.multiple === "true") {
      this.selected = [];
      this.load_data();
    }
    
  }
  
  load_data(){
    if(this.gameType === "memory"){
      var images = this.selectedFields.children;
      for (let index = 0; index < images.length; index++) {
        const element = images[index];
        this.selected.push(element.dataset.id)
      }
      this.selectedFieldsId.setAttribute('value', this.selected)
      this.selectedImagesLengthTarget.innerText = this.selected.length + "/9 selected"
    }
    // else{
    //   var images = this.imagesContainer.children;
    //   for (let index = 0; index < images.length; index++) {
    //     const element = images[index].firstElementChild;
    //     this.selected.push(element.dataset.id)
    //   }
    //   this.selectedFieldsId.setAttribute('value', this.selected)
    // }
  }

  select_multiple(event) {
    const target = event.target;
    if(this.selected.length < 9){
      if (this.selected.includes(target.dataset.id)) {
        this.remove_default_image(event);
    } else {
        if(target.hasAttribute("data-status")){
          target.parentNode.parentNode.removeChild(target.parentNode)
          target.className = "svg-view"
        }
        this.selectedFields.appendChild(target)
        this.selected.push(target.dataset.id);
        target.classList.add("active-borders");
        target.setAttribute("data-action", "click->game-campaign#remove_default_image")
      
      this.selectedFieldsId.setAttribute('value', this.selected)
      this.selectedImagesLengthTarget.innerText = this.selected.length + "/9 selected"
    }
    }
    else{
      alert("You can add up to 9 images!")
    }
  }

  delete_from_array(event){
    var target = event.target;
    for (var i = 0; i < this.selected.length; i++) {
      if (this.selected[i] === target.dataset.id) {
        this.selected.splice(i, 1);
        i--;
      }
    }
  }

  remove_default_image(event){
    const target = event.target;
    this.delete_from_array(event);
    target.setAttribute("data-action", "click->game-campaign#select_multiple")
    target.classList.remove("active-borders");
    if(target.hasAttribute("data-status")){
      target.className = "image-preview"
      this.previous_data(event)
      // this.imagesContainer.appendChild(imageDiv)
      
    }
    else{
      this.previousParent.appendChild(target)
    }
    this.selectedFieldsId.setAttribute('value', this.selected)
    this.selectedImagesLengthTarget.innerText = this.selected.length + "/9 selected"
  }

  remove_button(event){
    const button = event.target
    const mainParent = button.parentElement.parentElement
    this.imagesContainer.removeChild(mainParent);
  }

  previous_data(event){
    const target = event.target
    const imageDiv = document.createElement('div');
    imageDiv.classList.add("image");
    imageDiv.style = "width: 76px; height: 60px";

    const linkToRemove = document.createElement('a');
    linkToRemove.classList.add("remove-icon");
    linkToRemove.innerHTML = `<span style='color: red' class="material-icons">
    highlight_off
    </span>`;

    if(target.hasAttribute("data-status") && target.getAttribute("data-status") == "selected"){
      linkToRemove.addEventListener('click', (e) => {
        const element = target
        this.uploadedImagesArray.remove(target)
        this.imagesContainer.removeChild(element.parentElement);
      })
    }
    else if(target.hasAttribute("data-status") && target.getAttribute("data-status") == "uploaded"){
      linkToRemove.setAttribute("data-turbo-method", "post")
      linkToRemove.setAttribute("href", `/company/uploads/remove?image_id=${target.dataset.id}`)
      linkToRemove.addEventListener('click', (e) => {
        this.imagesContainer.removeChild(target.parentElement.parentElement);
      })
    }
    imageDiv.appendChild(target)
    imageDiv.appendChild(linkToRemove);
    this.imagesContainer.appendChild(imageDiv)
  }

  save_image(event){
    var id = event.target.dataset.id;
    var icon_ids = this.selectedFieldsId.value.split(',');
    icon_ids.push(id);
    this.selectedFieldsId.setAttribute('value', icon_ids);
    document.getElementById("slot_game_icons").submit();
  }

  attach_slot_icons(event){
    var files = event.target.files
    Object.entries(files).forEach(async ([key, val]) => {
      const img = document.createElement("img");
      const div = document.createElement("div");
      const url = URL.createObjectURL(val);
      const removeButton = document.createElement("a");

      div.className = "game-image-size image"
      img.classList.add('image-preview')
      img.src = url;
      div.appendChild(img);
      div.appendChild(removeButton);
      if(this.slotImagesContainer){
        removeButton.classList = "remove-icon";
        removeButton.innerHTML = `<span style='color: red' class="material-icons">
        highlight_off
        </span>`;
        img.setAttribute("data-action", "click->uploads#select game-campaign#save_image");
        img.setAttribute("data-status", "uploaded");

        var id = await this.upload_file(files[key]);
        removeButton.setAttribute("href", `/company/uploads/remove?image_id=${id}`)
        removeButton.setAttribute("data-turbo-method", "post")
        removeButton.setAttribute("data-action", "click->game-campaign#remove_button")
        img.setAttribute("data-id", id)
      } else {
        removeButton.innerHTML = `<img src="/assets/trash.svg" />`;
      }
      this.imagesContainer.appendChild(div);
    });
  }

  async upload_file(file){
    var id = document.getElementById("game_campaign_id").value;
    var data = new FormData()
    if(this.gameType !== null && this.gameType === "slot"){
      data.append("type", "slot")
    }
    else{
      data.append("type", "memory")
    }
    data.append("uploaded_image", file)
    const response = await fetch(`/company/game_campaigns/${id}/upload_images`, {
      method: "POST",
      body: data,
    });
    const responseData = await response.json();
    return responseData.attachment_id;
  }

}